import React, { useContext } from 'react'
import { Flex } from 'pcln-design-system'
import Pricebreakers from '@/components/Promos/Pricebreakers/Pricebreakers'
import VIPPromo from '@/components/Promos/VIP/VIPPromo'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import IncredibleTile from '@/components/Promos/IncredibleTile/IncredibleTile'
import useSeti from '@/components/CustomHooks/useSeti'

type PromoFeatureBoxProps = {
  isRedesignHero?: boolean
}

export default function PromoFeatureBox({
  isRedesignHero = false
}: PromoFeatureBoxProps) {
  const {
    isMobile = false,
    signInStatus: { signedIn = false }
  } = useContext(BootstrapDataContext)

  const isMblIncredibleTileVariant =
    useSeti('HP_MBL_INCREDIBLE_TILE', isMobile) === 'VARIANT'
  const heroRedesignSpacing =
    isRedesignHero && !isMobile
      ? {
          mt: [1, null, null, -4, 0],
          mb: [1, null, 4],
          style: { position: 'relative' }
        }
      : {
          my: [1, null, 4]
        }

  return (
    <Flex mx="auto" justifyContent="center" {...heroRedesignSpacing}>
      <Flex maxWidth={1280} px={[0, '20px']} flexWrap={['wrap', null, 'unset']}>
        {signedIn ? (
          <VIPPromo isMobile={isMobile} />
        ) : (
          <Pricebreakers isMobile={isMobile} />
        )}
        {(!isMobile || isMblIncredibleTileVariant) && (
          <IncredibleTile isRedesignHero={isRedesignHero} />
        )}
      </Flex>
    </Flex>
  )
}
